// src/components/ProductGrid/ProductGrid.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import ModelCard from './ModelCard';
import styles from './ProductGrid.module.scss';

function ProductGrid({
  modelos,
  loading,
  error,
  selectedSerieName,
  selectedSerieSlug,
  selectedLineaName,
  selectedLineaSlug
}) {
  const fadeUpVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  return (
    <div className={styles.productGridContainer}>
      <p className={styles.productGridDescription}>
        Descubre la gama completa de productos Zoomlion disponibles en Latinoamérica. Encuentra aquí el equipo ideal para tus proyectos de agricultura, infraestructura, construcción y minería.
      </p>

      {selectedSerieName && (
        <h2 className={styles.productGridBreadcrumb}>
          <span style={{ fontWeight: 300 }}>Modelos de la línea </span>
          <span style={{ fontWeight: 600 }}>
            <Link
              to={`/productos/${selectedLineaSlug}`}
              className={styles.productGridLineaLink}
            >
              {selectedLineaName}
            </Link>
          </span>
          <span style={{ fontWeight: 300 }}> y la serie </span>
          <span style={{ fontWeight: 600 }}>{selectedSerieName}</span>
          <span style={{ fontWeight: 300 }}>:</span>
        </h2>
      )}

      {selectedLineaName && !selectedSerieName && (
        <h2 className={styles.productGridBreadcrumb}>
          <span style={{ fontWeight: 300 }}>Modelos de la línea </span>
          <span style={{ fontWeight: 600 }}>
            <Link
              to={`/productos/${selectedLineaSlug}`}
              className={styles.productGridLineaLink}
            >
              {selectedLineaName}
            </Link>
          </span>
          <span style={{ fontWeight: 300 }}>:</span>
        </h2>
      )}

      <div className={styles.productGrid}>
        {!selectedSerieName && !selectedLineaName ? (
          <div className={styles.productGridMessage}>
            Selecciona una línea en el menú para ver los productos.
          </div>
        ) : loading ? (
          <div className={styles.productGridMessage}>
            Cargando modelos...
          </div>
        ) : error ? (
          <div className={styles.productGridMessage}>
            Error: {error}
          </div>
        ) : modelos.length === 0 ? (
          <div className={styles.productGridMessage}>
            No hay modelos disponibles
          </div>
        ) : (
          modelos.map(modelo => (
            <motion.div
              key={modelo.documentId}
              initial="hidden"
              animate="visible"
              variants={fadeUpVariants}
            >
              <ModelCard
                nombre={modelo.nombre}
                especificaciones={modelo.especificaciones}
                imagen={modelo.imagen_card || '/images/default-banner.webp'}
                slug={modelo.slug}
                selectedLineaSlug={selectedLineaSlug}
              />
            </motion.div>
          ))
        )}
      </div>
    </div>
  );
}

export default ProductGrid;
